import type { FunctionComponent } from "react";
import { useCallback } from "react";

import { Buffered, Played, Track } from "./styles";

export type Props = {
  bufferedFraction: number;
  currentTime: number;
  duration: number;
  onSeek: (seconds: number) => void;
};

/** Seekable progress strip for the chromeless player. Clicking the track
 * seeks to the proportional position.
 */
export const SCMPYoutubeVideoProgressBar: FunctionComponent<Props> = ({
  bufferedFraction,
  currentTime,
  duration,
  onSeek,
}) => {
  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLDivElement>) => {
      if (duration <= 0) return;

      const track = event.currentTarget.getBoundingClientRect();
      const fraction = (event.clientX - track.left) / track.width;
      onSeek(Math.min(Math.max(fraction, 0), 1) * duration);
    },
    [duration, onSeek],
  );

  return (
    <Track onClick={handleClick}>
      <Buffered style={{ inlineSize: `${Math.min(bufferedFraction * 100, 100)}%` }} />
      <Played
        style={{
          inlineSize: `${duration > 0 ? Math.min((currentTime / duration) * 100, 100) : 0}%`,
        }}
      />
    </Track>
  );
};

SCMPYoutubeVideoProgressBar.displayName = "SCMPYoutubeVideoProgressBar";
